import {Configuration, LogLevel, PopupRequest} from '@azure/msal-browser';

class MsalConfig {
  private clientId: string;
  private authority: string;
  private redirectUri: string;
  private postLogoutRedirectUri: string;

  constructor() {
    this.clientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID || '';
    this.authority = `${process.env.REACT_APP_MICROSOFT_AUTHORITY}/${process.env.REACT_APP_MICROSOFT_TENANT_ID}/`;
    this.redirectUri = process.env.REACT_APP_MICROSOFT_REDIRECT_URI || '';
    this.postLogoutRedirectUri =
      process.env.REACT_APP_MICROSOFT_LOGOUT_REDIRECT_URI || '';
  }

  public getConfiguration(): Configuration {
    return {
      auth: {
        clientId: this.clientId,
        authority: this.authority,
        redirectUri: this.redirectUri,
        postLogoutRedirectUri: this.postLogoutRedirectUri,
        navigateToLoginRequestUrl: false,
      },
      cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
      },
      system: {
        loggerOptions: {
          loggerCallback: (
            level: LogLevel,
            message: string,
            containsPii: boolean,
          ) => {
            if (containsPii) {
              return;
            }
            switch (level) {
              case LogLevel.Error:
                // console.error(message);
                return;
              case LogLevel.Info:
                // console.info(message);
                return;
              case LogLevel.Verbose:
                // console.debug(message);
                return;
              case LogLevel.Warning:
                // console.warn(message);
                return;
              default:
                return;
            }
          },
        },
      },
    };
  }

  public getLoginRequest(): PopupRequest {
    return {
      prompt: 'select_account',
      redirectUri: this.redirectUri,
      scopes: ['openid', 'profile', 'User.Read'],
    };
  }
}

const msalConfigInstance = new MsalConfig();

export const msalConfig = msalConfigInstance.getConfiguration();
export const loginRequest = msalConfigInstance.getLoginRequest();
